import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
	name: 'DateMatchPipe',
	pure: true//pure pipe is only called when Angular detects a change in the value or the parameters passed to a pipe
})
export class DateMatchPipe implements PipeTransform {
	transform(items: any[], date: Date): any {
		// console.group('DateMatchPipe||');
		// console.log('date:', date);
		// console.log('items:', items);
		// console.groupEnd();

		return items.filter(item => dayjs(item.date).format('YYYY-MM-DD') == dayjs(date).format('YYYY-MM-DD'));

	}
}